import React, { useCallback, useEffect, useRef, useState } from "react";
import SponsorshipCard from "../components/cards/SponsorshipCard";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../redux-stores/store";
import { CampaignFilters, defaultCampaignFilters, fetchCampaigns, fetchCampaignsThunk, updateCampaignFilters } from "../redux-stores/slices/campaignSlice";
import InfluencerActionCard from "../components/influencer/InfluencerActionCard";
import { useMediaQuery } from "react-responsive";
import { isDesktopMediaQuery } from "../constants/constants";
import CampaignSkeleton from "../skeletons/CampaignSkeleton";
import Ticker from "../components/header/Ticker";
import InvitedCampaigns from "../components/campaign/InvitedCampaigns";
import TaskSummary from "../components/collaborations/TaskSummary";
import "../styles/style.scss"
import { useSearchParams } from "react-router-dom";
import { decodeBase64, encodeBase64, generateUniqueKey } from "../utils/helpers";
import PendingSteps from "../components/collaborations/PendingSteps";
const Sponsorships: React.FC = () => {
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

    const [searchParams, setSearchParams] = useSearchParams();

    const queryFilters = searchParams.get('filters');
    const dispatch = useDispatch<AppDispatch>();
    const isDesktop = useMediaQuery(isDesktopMediaQuery)
    const connectionRequired = useSelector((state: RootState) => state.influencer.connectionRequired);
    const invitedCampaignsIds = useSelector((state: RootState) => state.campaigns.invited.list.map((c) => c.uuid));
    // Get campaigns and other necessary data from Redux store
    const filters = useSelector((state: RootState) => state.campaigns.filters);
    const [filterId, setFilterId] = useState(generateUniqueKey(filters, ['page']));
    const campaignsData = useSelector((state: RootState) => state.campaigns.filtered_lists[filterId!]);
    const campaigns = campaignsData?.list ?? [];
    const page = campaignsData?.page ?? 1;
    const has_more = campaignsData?.has_more ?? true;
    const loading = useSelector((state: RootState) => state.campaigns.loading);

    const [searchQuery, setSearchQuery] = useState('');
    const [initialLoading, setInitialLoading] = useState(true);

    const setFilters = (updatedFilters: CampaignFilters) => {

        const encodedFilters = encodeBase64(updatedFilters);

        setSearchParams({ filters: encodedFilters });
    }


    useEffect(() => {
        const decodedFilters = queryFilters ? decodeBase64(queryFilters, defaultCampaignFilters) : defaultCampaignFilters;
        dispatch(updateCampaignFilters({ ...decodedFilters, page: 1 }))
    }, [queryFilters])


    useEffect(() => {
        if (filters.page && filters.page === 1) {
            setInitialLoading(true);
        }
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            dispatch(fetchCampaignsThunk({ filters })).finally(() => {
                setFilterId(generateUniqueKey(filters, ['page']));
                setInitialLoading(false);
            })
        }, 500)

    }, [filters])

    useEffect(() => {
        setSearchQuery(filters.q ?? '');
    }, [filters.q])

    const nextPage = () => {
        if (has_more && !loading) {
            const nextPageNumber = page + 1;
            dispatch(fetchCampaignsThunk({ filters: { ...filters, page: nextPageNumber } }))
        }
    }

    const searchTask = (q: string) => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            if (q.trim().length > 3) {
                setFilters({ ...filters, q: q.trim(), page: 1 });
            } else if (q.trim().length === 0) {
                setFilters({ ...filters, q: '', page: 1 });
            }
        }, 500);
        setSearchQuery(q);
    }


    const invitesLoading = useSelector((state: RootState) => state.campaigns.invited.loading);


    return (
        <React.Fragment>
            <Ticker />
            {/* {
                connectionRequired && <InfluencerActionCard />
            } */}
            {/* <TaskSummary /> */}
            <PendingSteps />
            <InvitedCampaigns />
            <div className="d-flex px-3 align-items-center gap-3 justify-content-between mb-3">
                {
                    invitedCampaignsIds.length > 0 &&
                    <h4 className="sponsorships-title m-0 pop">All Campaigns</h4>
                }
                <div className="campaign-layout-search-container flex-grow-1 position-relative rounded-4">
                    <span>
                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.66732 14.0002C11.1651 14.0002 14.0007 11.1646 14.0007 7.66683C14.0007 4.16903 11.1651 1.3335 7.66732 1.3335C4.16951 1.3335 1.33398 4.16903 1.33398 7.66683C1.33398 11.1646 4.16951 14.0002 7.66732 14.0002Z" fill="#BBD8ED" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M15 16L12 13" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                    <input type="text" placeholder='Search...' value={searchQuery} onChange={(e) => searchTask(e.target.value)} className="campaign-layout-search-input" />
                    {
                        searchQuery &&
                        <span className='clear-search-icon'> <i className='fa fa-times' onClick={() => searchTask('')}></i> </span>
                    }
                </div>
            </div>

            <InfiniteScroll
                dataLength={campaigns.length} // Number of currently loaded campaigns
                next={nextPage}
                hasMore={has_more} // True if there are more campaigns to load
                loader={<></>}
            >
                {!initialLoading && campaigns.map((campaign) => {
                    // if(invitedCampaignsIds.includes(campaign.uuid)) return null;
                    return (<SponsorshipCard key={campaign.uuid} {...campaign} />)
                })}
            </InfiniteScroll>
            {
                (loading || invitesLoading || initialLoading) && Array.from({ length: isDesktop ? 3 : 2 }).map((_, i) => <CampaignSkeleton key={i} />)
            }
            {
                !initialLoading && !loading && campaigns.length === 0 &&
                <div className="card h-full card-style rounded-card">
                    <div className="card-body">
                        <div className="h-200px d-flex justify-content-center align-items-center text-center">
                            <div>
                                <h2 className="pop">No campaigns found!</h2>
                                <p className="text-muted">Currently there is no campaign in your list, try adjusting filters!</p>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    );
};

export default Sponsorships;